<template>
  <skeleton v-if="course.id === 0" />
  <div v-else
       class="page-course-detail-container"
  >
    <bottom-bar-layout v-if="loaded"
                       class="page-course-detail"
                       :show-bar="showBottomBar"
                       :bar-height="showVipBenefitBar ? 210 : 150"
                       barBackground="#fff"
                       :shadow="!showVipBenefitBar"
    >
      <course-layout v-if="course.id > 0">
        <!-- 顶部栏 -->
        <div v-if="!inAppWebView"
             class="page-course-detail-header-bar"
        >
          <ym-header-back-btn class="back-btn" />
          <div class="page-course-detail-header-bar-right">
            <ym-img class="icon"
                    :src="require('@/assets/img/course/icon_share.png')"
                    @click="showShareMask = true"
            />
            <router-link class="page-course-detail-header-bar-right-faq"
                         :to="{ name: 'HelpCenter' }"
                         v-ym-report:COURSE_DETAIL_HELPCENTER_CLICK=""
            >
              <ym-img class="icon"
                      :src="require('@/assets/img/course/icon_question.png')"
              />
            </router-link>
          </div>
        </div>
        <!-- 基本信息 -->
        <product-header-new :course="course"
                            :collect="collect"
                            :save-more="saveMore"
                            :render-price="headerRenderPrice"
                            :tab-selected="tabSelected"
        />
        <!-- 课前准备 -->
        <member-notice :id="course.id"
                       type="course"
                       :qr-code="qrCode"
                       :wechat-group="wechatGroup"
        />
        <!-- navbar -->
        <product-content-new id="product-detail-content-block"
                             v-model="tabSelected"
                             :nav-bar-list="navBarList"
                             :product="course"
                             product-type="course"
                             :is-member="isMember"
                             :sell="sell"
                             :action-btn="actionBtn"
                             :show-bottom-bar="showBottomBar"
                             @sticky="onTabSticky"
        />
        <!-- 咨询客服 -->
        <router-link v-if="!isMember"
                     :to="{ name: 'CustomerService', params: { type: 'course', id: course.id } }"
                     class="customer-service"
        >
          <ym-img class="customer-service-icon"
                  :src="require('@/assets/img/course/customer_service.png')"
          />
        </router-link>
        <!-- 写评价 -->
        <router-link v-if="!showBottomBar && tabSelected === 'review'"
                     :to="{ name: 'CreateReview', params: { type: 'course', id: course.id } }"
                     class="review-list-create-btn"
        >
          写评价
        </router-link>
      </course-layout>
      <template #tabbar>
        <div class="footer-container">
          <vip-benefit-bar v-if="showVipBenefitBar"
                           :save-more="saveMore"
                           :tab-selected="tabSelected"
                           fixed
          />
          <footer-bar :sell="sell"
                      :product="course"
                      :action-btn="actionBtn"
                      :render-price="footerRenderPrice"
                      :tab-selected="tabSelected"
          />
        </div>
      </template>
    </bottom-bar-layout>
    <empty-page v-else
                type="course"
                hint="正在加载数据..."
    />
    <share-mask :show.sync="showShareMask"
                :share-path="$wechat.getWechatMenuShareAppLink()"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>

</template>

<script>
  import { HeaderBackBtn } from '@ymba/ym-ui';
  import Skeleton from '@/skeleton/CourseDetail';
  import EmptyPage from '@/components/EmptyPage';
  import CourseLayout from '@/pages/Course/Layout';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import ProductHeaderNew from '@/components/ProductDetail/HeaderNew';
  import ProductContentNew from '@/components/ProductDetail/ContentNew';
  import VipBenefitBar from '@/components/ProductDetail/VipBenefitBar';
  import MemberNotice from '@/components/ProductDetailMemberNotice';
  import FooterBar from '@/components/ProductDetail/FooterBarNew';
  import ShareMask from '@/components/ShareMask';
  import { getCourseDetail } from '@/services/course';
  import { isAppWebView, isIosWebView, handleRunAppFn } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';
  import event from '@/utils/bus';

  export default {
    name: 'PageCourseDetail',
    components: {
      Skeleton,
      EmptyPage,
      BottomBarLayout,
      CourseLayout,
      ProductContentNew,
      MemberNotice,
      FooterBar,
      ProductHeaderNew,
      VipBenefitBar,
      'ym-header-back-btn': HeaderBackBtn,
      ShareMask,
    },
    metaInfo() {},
    data() {
      return {
        loaded: false,
        tabSelected: '',
        course: {},
        qrCode: {},
        wechatGroup: false,
        navBar: [],
        actionBtn: {},
        saveMore: {},
        collect: {},
        headerRenderPrice: {},
        footerRenderPrice: {},
        joinStatus: '',
        sell: {},
        showVipBenefitBar: false,
        showShareMask: false,
        showBottomBar: false,
      };
    },
    computed: {
      inAppWebView() {
        return isAppWebView();
      },
      isMember() {
        return this.joinStatus === 'member';
      },
      navBarList() {
        return this.navBar.filter(item => item.show);
      },
    },
    methods: {
      async initTabSelected(tabSelected) {
        await this.$nextTick();
        const hash = this.$route.hash.replace('#', '');
        this.tabSelected = tabSelected || hash || 'about';
      },
      handleAppWebviewToNative() {
        const route = this.$route;
        locationToAppWithRoute(route, true);
        handleRunAppFn(isIosWebView() ? 'releaseWebview' : 'dismissWebview');
      },
      async fetchData(id) {
        const data = await getCourseDetail(id);
        this.joinStatus = data.joinStatus;
        if (this.inAppWebView && this.isMember) {
          this.handleAppWebviewToNative();
          return;
        }
        this.course = data.product;
        this.saveMore = data.saveMore;
        this.collect = data.collect;
        this.navBar = data.navBar;
        this.headerRenderPrice = {
          originPrice: data.originPrice,
          discount: data.discount,
        };
        this.footerRenderPrice = {
          originPrice: data.bottomBar.originPrice,
          discount: data.bottomBar.discount,
        };
        this.sell = {
          startTime: data.bottomBar.sellStartTime,
          status: data.bottomBar.status,
          nextProductId: data.bottomBar.nextCourseId,
        };
        this.actionBtn = {
          action: data.bottomBar.joinButtonAction,
          hint: '立即购买',
          targetId: data.bottomBar.targetId,
          targetType: data.bottomBar.targetType,
        };
        this.showBottomBar = data.bottomBar.show;
        this.qrCode = data.notifyQrCode || { title: '', hint: '', src: '' };
        this.wechatGroup = data.showWechatGroup;
        this.loaded = true;
        const tabSelected = window.sessionStorage.getItem(`course-detail-${this.course.id}-tabSelected`);
        if (tabSelected) {
          await this.initTabSelected(tabSelected);
          window.sessionStorage.removeItem(`course-detail-${this.course.id}-tabSelected`);
          return;
        }
        await this.initTabSelected(this.isMember ? 'outline' : '');
      },
      onTabSticky(e) {
        if (this.saveMore) this.showVipBenefitBar = e;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
      event.$once('updateDetail', () => {
        this.fetchData(id);
      });
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(to.params.id);
      next();
    },
    beforeRouteLeave(to, from, next) {
      window.sessionStorage.setItem(`course-detail-${this.course.id}-tabSelected`, this.tabSelected);
      next();
    },
  };
</script>

<style lang="less" scoped>
  @import '~@/assets/styles/var.less';

  .page-course {
    &-detail-container {
      min-height: 100%;
      background: @color-white;
    }
    &-detail-header-bar {
      box-sizing: border-box;
      width: 100%;
      height: 88px;
      padding: 0 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-right {
        display: flex;
        align-items: center;
        .icon {
          width: 40px;
          height: 40px;
        }
        &-faq {
          margin-left: 40px;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  .footer-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  /deep/ .ym-tabs-title {
    color: @color-text-lighter;
    font-size: 30px;
    font-weight: bold;
    &.is-active {
      color: #13b9bf;
      font-size: @font-size-large;
    }
  }

  /deep/ .ym-tabs-line {
    width: 40px !important;
    height: 10px !important;
    border-radius: 5px !important;
  }

  .customer-service {
    position: fixed;
    bottom: 280px;
    right: 20px;
    z-index: 9;
    &-icon {
      width: 104px;
      height: 108px;
    }
  }

  .review-list-create-btn {
    position: fixed;
    bottom: 50px;
    z-index: 9;
    margin-left: 143px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 464px;
    height: 88px;
    border-radius: 22px;
    background-color: #02cccc;
    color: #fff;
    font-size: 30px;
    font-weight: @font-weight-bold;
  }
</style>
